// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__28BK3","header":"MergedInvoice_header__2Ebjj"};